var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sponsor-job-offers-list-component',{attrs:{"routeName":'admin-sponsor-jobs-offer-inputs'}})}
var staticRenderFns = []

export { render, staticRenderFns }